import { useMutation, } from "@tanstack/react-query";
export const createCertificationStepScoresheetsQueries = (requests, queryClient) => ({
    usePutCertificationStepScoresheetScore: (options = {}) => useMutation({
        ...options,
        mutationFn: async (payload) => {
            return requests.putCertificationStepScoresheetScore(payload);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["certification-step-scoresheets"],
            });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map